import { render, staticRenderFns } from "./ClientList.vue?vue&type=template&id=1f9e7655&scoped=true"
import script from "./ClientList.vue?vue&type=script&lang=ts"
export * from "./ClientList.vue?vue&type=script&lang=ts"
import style0 from "./ClientList.vue?vue&type=style&index=0&id=1f9e7655&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9e7655",
  null
  
)

export default component.exports